var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sectionClass,attrs:{"id":"AboutMeClients"}},[_c('div',{staticClass:"uk-child-width-1-4 uk-grid-medium uk-text-center",attrs:{"uk-grid":""}},_vm._l((12),function(n){return _c('div',[_c('img',{attrs:{"loading":"lazy","width":"80%","src":("/static/about-me/b" + n + ".webp")}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49894b7b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/about-me/AboutMeClients.vue
// module id = 416
// module chunks = 1